class ClGallery extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const thumb = target.closest('.cl-fly__thumb, .cl-gallery__thumb');
      if (!thumb) return;

      this.querySelectorAll('.is-active').forEach((item) => {
        item.classList.remove('is-active');
        item.setAttribute('aria-pressed', 'false');
      });
      thumb.classList.add('is-active');
      thumb.setAttribute('aria-pressed', 'true');

      const main = this.querySelector('[data-main]');
      if (main && thumb.dataset.src) {
        main.removeAttribute('srcset');
        main.src = thumb.dataset.src;
        if (thumb.dataset.alt !== undefined) main.alt = thumb.dataset.alt;
      }

    });
  }
}

customElements.get('cl-gallery') || customElements.define('cl-gallery', ClGallery);
